import keycloakService from '../keycloak_service';

import { sinatraOrigin } from '../config';

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

export const createPipeline = (pipelineName, workspaceID, pipelineSteps) => {
  const body = JSON.stringify({
    workspace_id: workspaceID,
    pipeline_id: pipelineName,
    definition: {
      steps: pipelineSteps
    },
  })

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToApi('v1/api/pipelines/create', fetchOptions)
}

export default createPipeline;
